import '@fortawesome/fontawesome-free/css/all.min.css';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';
import { FaShippingFast } from 'react-icons/fa';
import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';
import { addShippingAddress } from '../../services/userServices';
import apiClient from '../../utils/api-client';
import MyWishlist from './MyWishlist';
import UserProfilePic from './userProfile.png';


import { useNavigate } from 'react-router-dom'; // ✅ Import navigate

const AccountMain = () => {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  // ✅ Safe parse userData
  let storedUserData = null;
  try {
    storedUserData = JSON.parse(localStorage.getItem('userData'));
  } catch {
    storedUserData = null;
  }

  const userId = localStorage.getItem('userID');

  const [userData, setUserData] = useState(storedUserData);

  useEffect(() => {
    if (!storedUserData || !userId) {
      // Remove corrupted/empty storage
      localStorage.removeItem('userData');
      localStorage.removeItem('userID');

      // Redirect to login
      navigate('/login');
    }
  }, [storedUserData, userId, navigate]);

  const [shippingAddress, setShippingAddress] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadAPi, setLoadAPi] = useState(false);
  const [cities, setCities] = useState([]);

  const {
    register: formRegister,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchOrderDetail = async () => {
      try {
        if (userId) {
          const response = await apiClient.get(
            `/get-shipping-address/${userId}`
          );
          setShippingAddress(response.data.data);
          setIsLoading(false);
        }
      } catch (error) {}
    };
    fetchOrderDetail();
  }, [loadAPi]);

  const handleSetDefault = (user_id_fk, sa_id) => {
    if (isButtonDisabled) return;
    setIsButtonDisabled(true);
    apiClient
      .post('/change-address', { user_id_fk, sa_id })
      .then((response) => {
        toast.success(response.data.message);
        setLoadAPi(!loadAPi);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      })
      .finally(() => setIsButtonDisabled(false));
  };

  const onSubmit = (formData) => {
    setIsProcessing(true);
    addShippingAddress(formData)
      .then((response) => {
        if (response?.data.status === false) {
          const errorMessages = response.data.data.map((err) => err);
          toast.error(errorMessages.join(', '));
        } else if (response?.data.status === true) {
          toast.success('Shipping Address Added successfully');
          setShow(false);
          setLoadAPi(!loadAPi);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(() => {
        toast.error('An error occurred while adding shipping address.');
      })
      .finally(() => setIsProcessing(false));
  };

  const handleDeleteShippingAddress = (sa_id) => {
    apiClient
      .post(`/delete-shipping-address/${sa_id}`)
      .then((response) => {
        toast.success(response.data.message);
        setLoadAPi(!loadAPi);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  useEffect(() => {
    apiClient
      .get('/city')
      .then((res) => {
        setCities(res.data.data);
      })
      .catch(() => {});
  }, []);

  return (
    <section>
      {/* ===================== Styles ===================== */}
      <style>{`
    /* Button Styles */
    .btn-purple {
      background-color: #800080;
      color: #fff;
      border-radius: 8px;
    }
    .btn-purple:hover {
      background-color: #6a006a;
      color: yellow;
    }

    .btn-outline-purple {
      border: 1px solid #800080;
      color: #800080;
      border-radius: 8px;
    }
    .btn-outline-purple:hover {
      background-color: #800080;
      color: #fff;
    }

    /* Text and Misc Styles */
    .text-purple { color: #800080; }
    .card { border-radius: 12px; }
    .cursor-pointer { cursor: pointer; }

    /* Modal Fix: Prevent layout shift on open */
    body.modal-open {
      padding-right: 0 !important;
    }
  `}</style>

      {/* ===================== User Info ===================== */}
      <div className="row align-items-center my-4">
        <div className="col-auto">
          <img
            // src={
            //   userData?.profile_pic
            //     ? `${IMAGE_BASE_URL}/${userData?.profile_pic}`
            //     : UserProfilePic
            // }
            src={UserProfilePic}
            alt="Profile"
            className="rounded-circle img-fluid border"
            style={{
              width: '70px',
              height: '70px',
              objectFit: 'cover',
              draggable: 'false',
            }}
          />
        </div>

        <div className="col">
          <h5 className="mb-1">
            {userData?.full_name || <Skeleton width={100} />}
          </h5>
          <div className="text-muted small flex-column d-flex">
            <span className="me-3">
              Email: {userData?.email || <Skeleton width={100} />}
            </span>
            <span>Phone: {userData?.phone || <Skeleton width={100} />}</span>
          </div>
        </div>
      </div>

      <hr />

      {/* ===================== Shipping Addresses ===================== */}
      <div className="my-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0 fw-bold">Shipping Addresses</h5>
          <button
            className="btn btn-purple btn-sm"
            type="button"
            onClick={handleShow}
          >
            + Add Address
          </button>
        </div>

        {shippingAddress.length > 0 ? (
          <div className="row g-3">
            {isLoading && <Skeleton count={3} width={400} />}

            {shippingAddress.map((item) => (
              <div className="col-12 col-md-6" key={item.sa_id}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-3">
                    {/* Address Line */}
                    <p
                      className="text-truncate mb-1"
                      style={{
                        maxWidth: window.innerWidth < 768 ? '300px' : '100%',
                      }}
                    >
                      <i className="fa-solid fa-location-dot me-2 text-purple" />
                      <span>{item.street_address}</span>
                    </p>

                    {/* Name & Phone */}
                    <small className="text-muted">
                      Name: {item.receiver_name} <br />
                      Phone: {item.receiver_phone}
                    </small>

                    {/* Actions */}
                    <div className="mt-3 d-flex align-items-center">
                      {item.is_default === 1 ? (
                        <span className="badge px-3 py-2 bg-secondary">
                          Default
                        </span>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            className="btn btn-outline-purple btn-sm me-2"
                            onClick={() =>
                              handleSetDefault(item.user_id_fk, item.sa_id)
                            }
                            disabled={isButtonDisabled}
                          >
                            {isButtonDisabled ? 'Setting...' : 'Set Default'}
                          </button>

                          <i
                            className="fa-solid fa-trash-can text-danger btn p-1 btn-sm mb-2 fs-5 cursor-pointer"
                            onClick={() =>
                              handleDeleteShippingAddress(item.sa_id)
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted d-flex flex-column align-items-center justify-content-center py-5">
            <span>
              <FaShippingFast className="me-2" /> No shipping addresses added
              yet.
            </span>
            <button
              className="btn btn-purple btn-sm mt-3"
              type="button"
              onClick={handleShow}
            >
              + Add Address
            </button>
          </p>
        )}
      </div>

      {/* ===================== Add Shipping Modal ===================== */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        scrollable
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Shipping Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Name & Phone */}
            <div className="row mb-3">
              <div className="col-md-6 col-12">
                <label className="mb-2 text-muted">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Example"
                  {...formRegister('receiver_name', { required: true })}
                />
              </div>

              <div className="col-md-6 col-12">
                <label className="mb-2 text-muted">Phone Number</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="03123456789"
                  {...formRegister('receiver_phone', {
                    required: true,
                    pattern: /^03\d{9}$/,
                  })}
                />
                {errors.receiver_phone && (
                  <p className="text-danger">
                    Please enter correct phone number, Start with 03
                  </p>
                )}
              </div>
            </div>

            {/* Zip & City */}
            <div className="row g-3 mb-3">
              <div className="col-md-6 col-12">
                <label className="mb-2 text-muted">Zip Code</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="123456"
                  {...formRegister('zip_code', { required: true })}
                />
              </div>

              <div className="col-md-6 col-12">
                <label className="mb-2 text-muted">City</label>
                <select
                  className="form-control"
                  {...formRegister('city_id_fk', { required: true })}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city.city_id} value={city.city_id}>
                      {city.city_name}
                    </option>
                  ))}
                </select>
              </div>

              <input
                type="hidden"
                value={userId}
                {...formRegister('user_id_fk', { required: true })}
              />
            </div>

            {/* Street Address */}
            <div className="row g-3 mb-3">
              <div className="col-md-12 col-12">
                <label className="mb-2 text-muted">Address</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="123 Main St"
                  {...formRegister('street_address', {
                    required: true,
                    maxLength: 100,
                  })}
                />
              </div>
            </div>

            {/* Footer Actions */}
            <div className="d-flex justify-content-between">
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <button
                type="submit"
                className="btn btn-purple border-0"
                disabled={isProcessing}
              >
                {isProcessing ? 'Adding...' : 'Add Shipping Address'}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <hr />

      {/* ===================== Wishlist ===================== */}
      <div className="my-4">
        <h5 className="fw-bold">My Wishlist</h5>
        <MyWishlist />
      </div>
    </section>
  );
};

export default AccountMain;
